export default __webpack_public_path__ + "static/media/Homescreen-03.77d3d67d.jpg";